<div class="modal-header">
    <h4 class="modal-title">{{ contact.firstName }} {{ contact.lastName }}</h4>
    <button type="button" class="close" (click)="activeModal.close()">
        <span>×</span>
    </button>
</div>
<div class="modal-body p-0">
    <div class="message">
        {{ contact.message }}
    </div>
    <div class="reason">
        {{ contact.reason }}
    </div>
    <div class="phone">
        {{ contact.phone }}
    </div>
    <div class="email">
        {{ contact.emailAddress }}
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-sm btn-secondary" (click)="activeModal.close()">Close</button>
</div>
